import React, { ComponentProps, memo } from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import { createNumberMask } from 'text-mask-addons';

import { TextInput } from '../';

import { InputMaskCurrency } from 'pages/Private/FineSimulator/components/InputMask';

import { setGlobal } from 'reactn';
import ptBR from 'date-fns/locale/pt-BR';

setGlobal({
  locale: ptBR,
});

export const masks = {
  phone: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  period: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  digit: [/[0-9]/],
  number: createNumberMask({
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    prefix: '',
  }),
  numberInput: createNumberMask({
    includeThousandsSeparator: false,
    prefix: '',
  }),
  float: createNumberMask({
    includeThousandsSeparator: true,
    allowDecimal: true,
    decimalSymbol: ',',
    thousandsSeparatorSymbol: '.',
    prefix: '',
  }),
  currency: createNumberMask({
    includeThousandsSeparator: true,
    includeDecimalSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    prefix: 'R$ ',
    allowLeadingZeroes: false,
  }),
  newCurrency: createNumberMask({
    prefix: '',
  }),
};

interface IProps extends ComponentProps<typeof TextInput> {
  mask: keyof typeof masks;
}

const MaskInputComponent: React.FC<IProps> = ({ mask = 'number', onChange, ...props }) => {
  return (
    <MaskedInput
      mask={masks[mask]}
      guide={false}
      render={(ref, maskProps) => <TextInput inputRef={ref} {...maskProps} {...props} />}
      onChange={onChange}
    />
  );
};

export const MaskInput = memo(MaskInputComponent);

const MaskInputComponentReactHookForm: React.FC<MaskedInputProps> = ({ ...rest }) => {
  return (
    <MaskedInput
      mask={[]}
      guide={false}
      render={(ref, maskProps) => <InputMaskCurrency ref={ref} {...maskProps} {...rest} />}
    />
  );
};

export const InputCurrency = memo(MaskInputComponentReactHookForm);
